/** @format */
import { AxiosError } from 'axios';

import { AxiosValidationError } from '../types';

export type ValidationErrorResponse = {
    data?: {
        errors?: Record<string, string | string[]>;
    };
};

function responseRejected(error: AxiosError<ValidationErrorResponse>) {
    // Get the first validation message for each form field
    if (
        !error.response?.data?.data?.errors ||
        typeof error.response?.data?.data?.errors !== 'object'
    ) {
        return Promise.reject(error);
    }
    const validationErrors: Record<string, string> = Object.entries(
        error.response.data.data.errors
    ).reduce<Record<string, string>>(
        (validationErrors, [fieldName, fieldValue]) => {
            validationErrors[fieldName] = Array.isArray(fieldValue)
                ? fieldValue[0]
                : fieldValue;
            return validationErrors;
        },
        {}
    );
    return Promise.reject({
        ...error,
        validationErrors,
    } as AxiosValidationError);
}

export const validationMessagesInterceptor = {
    responseRejected,
};
